let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("6k2Ml")).then(() => parcelRequire('428T7'));